import { ColDef } from '@ag-grid-enterprise/all-modules'
import { initialCrudModelBaseState, CrudModelPaginator } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ConfigurationAssaygroupResponse } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.dto'
import { AssaygroupTypeEnum } from '@/api/services/common/assaygroup/common-assaygroup.dto'
import { configurationAssaygroupService } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.service'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'

export const columnsDefAssayGroupGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.externalCode'),
            field: 'code',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.assayGroup'),
            field: 'name',
            minWidth: 280,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.type'),
            field: 'type',
            minWidth: 80,
            suppressSizeToFit: true,
            filter: true,
            filterParams: {
                newRowsAction: 'keep',
                suppressMiniFilter: true,
                values: Object.keys(AssaygroupTypeEnum)
            }
        }
    ]

export interface ConfigurationAssaysGroupsGridState extends CrudModelPaginator<ConfigurationAssaygroupResponse> {
    service: typeof configurationAssaygroupService
}
export const initialConfigurationAssaysGroupsGridState =
    (): ConfigurationAssaysGroupsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.assays.assays-groups',
        columnsDef: columnsDefAssayGroupGrid(),
        datasource: new PaginatorDatasource(configurationAssaygroupService),
        service: configurationAssaygroupService
    })
